(function() {
  'use strict';
  
  // Helper: Get Flickity instance for a container
  function getFlickityForContainer(container) {
    // Find the carousel that contains this container
    const carousel = container.closest('.carousel-main');
    if (!carousel) return null;
    
    // Get Flickity instance using jQuery
    const $carousel = $(carousel);
    if (!$carousel.length) return null;
    
    return $carousel.data('flickity');
  }
  
  // Enable/disable Flickity dragging for product sliders
  function setProductSlidersDraggable(enabled) {
    // Use generic selectors that work across all product templates
    // Desktop carousel: any .carousel-main that is NOT inside .img-mobile-slider
    const $mainSlider = $('.carousel-main').not('.img-mobile-slider .carousel-main').first();
    const $mobileSlider = $('.img-mobile-slider .carousel-main');
    
    if ($mainSlider.length && $mainSlider.data('flickity')) {
      const flkty = $mainSlider.data('flickity');
      flkty.options.draggable = enabled;
      flkty.updateDraggable();
      // Add class to prevent CSS from hiding cells when dragging is disabled
      if (enabled) {
        $mainSlider.removeClass('zoom-mode-active');
      } else {
        $mainSlider.addClass('zoom-mode-active');
      }
    }
    
    if ($mobileSlider.length && $mobileSlider.data('flickity')) {
      const flkty = $mobileSlider.data('flickity');
      flkty.options.draggable = enabled;
      flkty.updateDraggable();
      // Add class to prevent CSS from hiding cells when dragging is disabled
      if (enabled) {
        $mobileSlider.removeClass('zoom-mode-active');
      } else {
        $mobileSlider.addClass('zoom-mode-active');
      }
    }
  }
  
  // Initialize zoom for a single image container
  function initZoomForContainer(container, img) {
    // Skip if already initialized
    if (container.dataset.zoomInitialized === 'true') {
      return;
    }
    
    // Mark as initialized
    container.dataset.zoomInitialized = 'true';
    
    // Add zoom-container class if not present
    if (!container.classList.contains('zoom-container')) {
      container.classList.add('zoom-container');
    }
    
    // Ensure image has ID or use data attribute
    if (!img.id && !img.dataset.zoomImage) {
      img.dataset.zoomImage = 'true';
    }
    
    const zoomLevels = [1, 1.5, 2, 3];
    let zoomIndex = 0;
    let isDragging = false;
    
    const DRAG_THRESHOLD = 5; // pixels
    const MIN_PINCH_SCALE = 1; // Minimum zoom level
    const MAX_PINCH_SCALE = 3; // Maximum zoom level
    
    // Helper function to calculate distance between two touches
    function getTouchDistance(touch1, touch2) {
      const dx = touch2.clientX - touch1.clientX;
      const dy = touch2.clientY - touch1.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }
    
    // Helper function to calculate center point between two touches
    function getTouchCenter(touch1, touch2) {
      return {
        x: (touch1.clientX + touch2.clientX) / 2,
        y: (touch1.clientY + touch2.clientY) / 2
      };
    }
    
    // Helper function to find nearest discrete zoom level
    function snapToNearestZoomLevel(scale) {
      let nearestIndex = 0;
      let minDiff = Math.abs(scale - zoomLevels[0]);
      
      for (let i = 1; i < zoomLevels.length; i++) {
        const diff = Math.abs(scale - zoomLevels[i]);
        if (diff < minDiff) {
          minDiff = diff;
          nearestIndex = i;
        }
      }
      
      return nearestIndex;
    }
    
    // Calculate and cache base dimensions (at scale 1) if not already stored
    function getBaseDimensions() {
      // If base dimensions are already cached and valid, use them
      if (container.zoomState.baseWidth && container.zoomState.baseHeight && 
          container.zoomState.baseWidth > 0 && container.zoomState.baseHeight > 0) {
        return {
          width: container.zoomState.baseWidth,
          height: container.zoomState.baseHeight
        };
      }
      
      // Get container dimensions first
      const containerRect = container.getBoundingClientRect();
      const containerWidth = containerRect.width;
      const containerHeight = containerRect.height;
      
      // Try to get base dimensions from image's natural size first (most accurate)
      // But account for CSS constraints (object-fit, max-width, etc.)
      let baseWidth = img.naturalWidth;
      let baseHeight = img.naturalHeight;
      
      // If natural dimensions are available, calculate displayed size at scale 1
      // by considering the container constraints
      if (baseWidth && baseHeight && baseWidth > 0 && baseHeight > 0) {
        // Calculate aspect ratios
        const imgAspect = baseWidth / baseHeight;
        const containerAspect = containerWidth / containerHeight;
        
        // Determine displayed size based on object-fit behavior (typically cover or contain)
        // Most product images use cover, so the image fills the container
        // We'll use container dimensions as the base for boundary calculations
        // This ensures boundaries match the actual displayed area
        baseWidth = containerWidth;
        baseHeight = containerHeight;
      } else {
        // Fallback: use current displayed size divided by current scale
        const imgRect = img.getBoundingClientRect();
        const currentScale = container.zoomState?.zoomIndex !== undefined ? zoomLevels[container.zoomState.zoomIndex] || 1 : 1;
        
        baseWidth = imgRect.width / currentScale;
        baseHeight = imgRect.height / currentScale;
        
        // If still invalid, use container size
        if (!baseWidth || !baseHeight || baseWidth === 0 || baseHeight === 0 || !isFinite(baseWidth) || !isFinite(baseHeight)) {
          baseWidth = containerWidth;
          baseHeight = containerHeight;
        }
      }
      
      // Cache the base dimensions
      container.zoomState.baseWidth = baseWidth;
      container.zoomState.baseHeight = baseHeight;
      
      return {
        width: baseWidth,
        height: baseHeight
      };
    }
    
    // Calculate pan boundaries to prevent whitespace
    function getPanBoundaries(scale) {
      const containerRect = container.getBoundingClientRect();
      const containerWidth = containerRect.width;
      const containerHeight = containerRect.height;
      
      // Get base dimensions (cached or calculated)
      const baseDims = getBaseDimensions();
      const baseWidth = baseDims.width;
      const baseHeight = baseDims.height;
      
      // Calculate scaled dimensions at the target scale
      const scaledWidth = baseWidth * scale;
      const scaledHeight = baseHeight * scale;
      
      // Calculate maximum allowed translation in the original coordinate space
      // Translation values are in pixels relative to the base (scale 1) image size
      // If scaled size is smaller than or equal to container, no panning allowed
      const maxX = scaledWidth > containerWidth ? (scaledWidth - containerWidth) / (2 * scale) : 0;
      const maxY = scaledHeight > containerHeight ? (scaledHeight - containerHeight) / (2 * scale) : 0;
      
      return {
        minX: -maxX,
        maxX: maxX,
        minY: -maxY,
        maxY: maxY
      };
    }
    
    // Store zoom state on container
    container.zoomState = {
      zoomIndex: 0,
      currentX: 0,
      currentY: 0,
      baseWidth: null,
      baseHeight: null
    };
    
    // Store drag detection state on container
    container.dragState = {
      wasDragGesture: false,
      pointerDownX: null,
      pointerDownY: null
    };
    
    // Get Flickity instance for this container's carousel
    const flkty = getFlickityForContainer(container);
    if (!flkty) {
      return;
    }
    
    // Perform zoom action (reusable function for both desktop and mobile)
    function performZoom() {
      zoomIndex = (zoomIndex + 1) % zoomLevels.length;
      const scale = zoomLevels[zoomIndex];
      
      // Update stored state
      container.zoomState.zoomIndex = zoomIndex;
      
      // Reset position to center when returning to normal size (scale = 1)
      if (scale === 1) {
        container.zoomState.currentX = 0;
        container.zoomState.currentY = 0;
      } else {
        // Clamp position to boundaries when zoom level changes
        const boundaries = getPanBoundaries(scale);
        container.zoomState.currentX = Math.max(boundaries.minX, Math.min(boundaries.maxX, container.zoomState.currentX));
        container.zoomState.currentY = Math.max(boundaries.minY, Math.min(boundaries.maxY, container.zoomState.currentY));
      }
      
      img.style.transform = `scale(${scale}) translate(${container.zoomState.currentX}px, ${container.zoomState.currentY}px)`;
      
      if (scale > 1) {
        container.classList.add('zoomed');
        // When zoomed in, disable Flickity dragging so drag pans the image only
        setProductSlidersDraggable(false);
      } else {
        container.classList.remove('zoomed');
        // When zoom is reset, re-enable Flickity dragging so drag changes slides
        setProductSlidersDraggable(true);
      }
      
      // Reset drag state after zoom
      container.dragState.wasDragGesture = false;
      container.dragState.pointerDownX = null;
      container.dragState.pointerDownY = null;
    }
    
    // CLICK TO ZOOM - Use Flickity's staticClick event (fires only on genuine clicks, not drags)
    function handleStaticClick(event, pointer, cellElement, cellIndex) {
      // Only handle if this container was clicked
      if (cellElement !== container) {
        return;
      }
      
      // Don't zoom if clicking on carousel navigation or other elements
      if (pointer.target && (pointer.target.closest('.carousel-nav') || pointer.target.closest('button'))) {
        return;
      }
      
      // Reset drag state at the start of each click interaction to prevent stale state
      // This ensures each click starts fresh
      const wasDrag = container.dragState.wasDragGesture;
      container.dragState.wasDragGesture = false;
      container.dragState.pointerDownX = null;
      container.dragState.pointerDownY = null;
      
      // Check if this was a drag gesture (not a click)
      if (wasDrag) {
        setProductSlidersDraggable(true);
        return;
      }
      
      performZoom();
    }
    
    // Native DOM mousedown handler (works even when Flickity draggable is false)
    function handleContainerMouseDown(e) {
      // Only handle if this container was the target
      if (!container.contains(e.target)) {
        return;
      }
      
      // Don't handle if clicking on carousel navigation or buttons
      if (e.target.closest('.carousel-nav') || e.target.closest('button')) {
        return;
      }
      
      // Record initial pointer position for drag detection using event object
      const pointerX = e.clientX;
      const pointerY = e.clientY;
      container.dragState.pointerDownX = pointerX;
      container.dragState.pointerDownY = pointerY;
      container.dragState.wasDragGesture = false;
      
      // Check stored zoom state instead of local variable
      const currentZoomIndex = container.zoomState?.zoomIndex || 0;
      const currentScale = zoomLevels[currentZoomIndex];
      
      if (currentScale === 1) {
        // Even if not zoomed, track pointer down for drag detection
        return;
      }
      
      isDragging = true;
      container.style.cursor = 'grabbing';
      
      // Store dragging state and initial pointer position in container state
      container.zoomState.isDragging = true;
      container.zoomState.lastPointerX = pointerX;
      container.zoomState.lastPointerY = pointerY;
      
      // Attach document-level listeners for panning (works even when Flickity draggable is false)
      document.addEventListener('mousemove', handleDocumentMouseMove);
      document.addEventListener('mouseup', handleDocumentMouseUp);
      document.addEventListener('touchmove', handleDocumentTouchMove, { passive: false });
      document.addEventListener('touchend', handleDocumentTouchEnd);
      
      // Prevent Flickity from handling this drag
      e.preventDefault();
      e.stopPropagation();
    }
    
    // Native DOM touchstart handler for mobile
    function handleContainerTouchStart(e) {
      // Only handle if this container was the target
      if (!container.contains(e.target)) {
        return;
      }
      
      // Don't handle if clicking on carousel navigation or buttons
      if (e.target.closest('.carousel-nav') || e.target.closest('button')) {
        return;
      }
      
      // Check for pinch gesture (two touches)
      if (e.touches && e.touches.length === 2) {
        // Pinch gesture detected
        const touch1 = e.touches[0];
        const touch2 = e.touches[1];
        
        // Ensure zoomState exists
        if (!container.zoomState) {
          container.zoomState = {
            zoomIndex: 0,
            currentX: 0,
            currentY: 0,
            baseWidth: null,
            baseHeight: null
          };
        }
        
        // Initialize pinch state
        if (!container.zoomState.pinchState) {
          container.zoomState.pinchState = {};
        }
        
        const currentZoomIndex = container.zoomState?.zoomIndex || 0;
        const currentScale = zoomLevels[currentZoomIndex];
        
        // Store initial pinch distance and center point
        container.zoomState.pinchState.initialDistance = getTouchDistance(touch1, touch2);
        container.zoomState.pinchState.initialCenter = getTouchCenter(touch1, touch2);
        container.zoomState.pinchState.initialScale = currentScale;
        container.zoomState.pinchState.isPinching = true;
        container.zoomState.pinchState.initialPanX = container.zoomState.currentX || 0;
        container.zoomState.pinchState.initialPanY = container.zoomState.currentY || 0;
        
        // Disable Flickity dragging during pinch
        setProductSlidersDraggable(false);
        
        // Prevent browser zoom
        e.preventDefault();
        
        // Attach document-level listeners for pinch tracking
        document.addEventListener('touchmove', handleDocumentTouchMove, { passive: false });
        document.addEventListener('touchend', handleDocumentTouchEnd);
        
        return;
      }
      
      // Single touch handling (existing logic)
      const touch = e.touches && e.touches[0];
      if (!touch) return;
      
      // Record initial pointer position for drag detection using event object
      const pointerX = touch.clientX;
      const pointerY = touch.clientY;
      container.dragState.pointerDownX = pointerX;
      container.dragState.pointerDownY = pointerY;
      container.dragState.wasDragGesture = false;
      
      // Check stored zoom state instead of local variable
      const currentZoomIndex = container.zoomState?.zoomIndex || 0;
      const currentScale = zoomLevels[currentZoomIndex];
      
      // Always attach document-level listeners for both zoom tap detection and panning
      // This allows us to detect taps on mobile even when not zoomed
      document.addEventListener('touchmove', handleDocumentTouchMove, { passive: false });
      document.addEventListener('touchend', handleDocumentTouchEnd);
      
      // Store initial position for potential panning (but don't start panning yet)
      // We'll only start panning if movement is detected in touchmove
      container.zoomState.lastPointerX = pointerX;
      container.zoomState.lastPointerY = pointerY;
      
      if (currentScale === 1) {
        // At normal size, just track for tap detection (zoom will be handled in touchend)
        // Don't prevent default yet - let Flickity handle carousel navigation if it's a drag
        return;
      }
      
      // If zoomed, also attach mouse events for hybrid devices
      // But don't set isDragging yet - wait for touchmove to detect actual movement
      document.addEventListener('mousemove', handleDocumentMouseMove);
      document.addEventListener('mouseup', handleDocumentMouseUp);
      
      // Don't prevent default yet - let touchmove decide if it's a pan or tap
      // We'll prevent default in touchmove if movement is detected
    }
    
    // DRAG TO MOVE - Use Flickity's pointerDown event (fallback, may not fire when draggable is false)
    function handlePointerDown(event, pointer) {
      // Only handle if this container was the target
      const targetElement = event.target || pointer.target;
      if (!container.contains(targetElement)) {
        return;
      }
      
      // Record initial pointer position for drag detection using event object
      const pointerX = event.clientX !== undefined ? event.clientX : (event.touches && event.touches[0] ? event.touches[0].clientX : pointer.pageX || pointer.clientX);
      const pointerY = event.clientY !== undefined ? event.clientY : (event.touches && event.touches[0] ? event.touches[0].clientY : pointer.pageY || pointer.clientY);
      container.dragState.pointerDownX = pointerX;
      container.dragState.pointerDownY = pointerY;
      container.dragState.wasDragGesture = false;
      
      // Check stored zoom state instead of local variable
      const currentZoomIndex = container.zoomState?.zoomIndex || 0;
      const currentScale = zoomLevels[currentZoomIndex];
      
      if (currentScale === 1) {
        // Even if not zoomed, track pointer down for drag detection
        return;
      }
      
      if (targetElement.closest('.carousel-nav')) return;
      
      isDragging = true;
      container.style.cursor = 'grabbing';
      
      // Store dragging state and initial pointer position in container state
      container.zoomState.isDragging = true;
      container.zoomState.lastPointerX = pointerX;
      container.zoomState.lastPointerY = pointerY;
      
      // Attach document-level listeners for panning (works even when Flickity draggable is false)
      document.addEventListener('mousemove', handleDocumentMouseMove);
      document.addEventListener('mouseup', handleDocumentMouseUp);
      document.addEventListener('touchmove', handleDocumentTouchMove, { passive: false });
      document.addEventListener('touchend', handleDocumentTouchEnd);
      
      // Prevent Flickity from handling this drag
      event.preventDefault();
    }
    
    // Document-level mousemove handler for panning (works even when Flickity draggable is false)
    function handleDocumentMouseMove(e) {
      // Always check for drag detection (even when not panning) using event object
      if (container.dragState.pointerDownX !== null && container.dragState.pointerDownY !== null) {
        const currentPointerX = e.clientX;
        const currentPointerY = e.clientY;
        const dx = Math.abs(currentPointerX - container.dragState.pointerDownX);
        const dy = Math.abs(currentPointerY - container.dragState.pointerDownY);
        
        // If movement exceeds threshold, mark as drag gesture
        if (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD) {
          container.dragState.wasDragGesture = true;
        }
      }
      
      // Only do panning logic if we're actually panning (image is zoomed)
      // Check container's stored state instead of local variable
      if (!container.zoomState || !container.zoomState.isDragging) {
        return;
      }
      
      // Get current zoom state from container
      const currentZoomIndex = container.zoomState.zoomIndex || 0;
      const scale = zoomLevels[currentZoomIndex];
      
      // Get current position from stored state
      let panX = container.zoomState.currentX || 0;
      let panY = container.zoomState.currentY || 0;
      
      // Get current pointer position directly from event
      const currentPointerX = e.clientX;
      const currentPointerY = e.clientY;
      
      // Get last pointer position (from when dragging started or last move)
      // If this is the first move after mousedown, use the initial position
      const lastX = container.zoomState.lastPointerX !== null && container.zoomState.lastPointerX !== undefined 
        ? container.zoomState.lastPointerX 
        : currentPointerX;
      const lastY = container.zoomState.lastPointerY !== null && container.zoomState.lastPointerY !== undefined 
        ? container.zoomState.lastPointerY 
        : currentPointerY;
      
      // Calculate delta (how much the mouse moved since last position)
      const dx = currentPointerX - lastX;
      const dy = currentPointerY - lastY;
      
      // Update stored last position for next delta calculation
      container.zoomState.lastPointerX = currentPointerX;
      container.zoomState.lastPointerY = currentPointerY;
      
      // Update position: translate values are in the original coordinate space
      // When image is scaled 2x, moving mouse 10px should translate image by 10px/2 = 5px
      // This makes the visual movement match the mouse movement (5px * 2 = 10px visual)
      panX += dx / scale;
      panY += dy / scale;
      
      // Clamp pan values to prevent whitespace
      const boundaries = getPanBoundaries(scale);
      panX = Math.max(boundaries.minX, Math.min(boundaries.maxX, panX));
      panY = Math.max(boundaries.minY, Math.min(boundaries.maxY, panY));
      
      // Update stored state
      container.zoomState.currentX = panX;
      container.zoomState.currentY = panY;
      
      img.style.transform = `scale(${scale}) translate(${panX}px, ${panY}px)`;
    }
    
    // Document-level mouseup handler
    function handleDocumentMouseUp(e) {
      // Final check for drag detection using event object
      if (container.dragState.pointerDownX !== null && container.dragState.pointerDownY !== null) {
        const currentPointerX = e.clientX;
        const currentPointerY = e.clientY;
        const dx = Math.abs(currentPointerX - container.dragState.pointerDownX);
        const dy = Math.abs(currentPointerY - container.dragState.pointerDownY);
        
        // If movement exceeds threshold, mark as drag gesture
        if (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD) {
          container.dragState.wasDragGesture = true;
        }
      }
      
      if (isDragging || (container.zoomState && container.zoomState.isDragging)) {
        isDragging = false;
        if (container.zoomState) {
          container.zoomState.isDragging = false;
          container.zoomState.lastPointerX = null;
          container.zoomState.lastPointerY = null;
        }
        container.style.cursor = '';
        // Remove document-level listeners
        document.removeEventListener('mousemove', handleDocumentMouseMove);
        document.removeEventListener('mouseup', handleDocumentMouseUp);
        document.removeEventListener('touchmove', handleDocumentTouchMove);
        document.removeEventListener('touchend', handleDocumentTouchEnd);
      }
      
      // Note: Don't reset dragState here - let staticClick handler check it first
      // It will reset after handling the click (or skipping it if drag was detected)
    }
    
    // Document-level touchmove handler for mobile panning and pinch
    function handleDocumentTouchMove(e) {
      // Handle pinch gesture (two touches)
      if (e.touches && e.touches.length === 2 && container.zoomState && container.zoomState.pinchState && container.zoomState.pinchState.isPinching) {
        const touch1 = e.touches[0];
        const touch2 = e.touches[1];
        
        // Calculate current pinch distance
        const currentDistance = getTouchDistance(touch1, touch2);
        const initialDistance = container.zoomState.pinchState.initialDistance;
        
        if (initialDistance > 0) {
          // Calculate scale change
          const scaleChange = currentDistance / initialDistance;
          const newScale = Math.max(MIN_PINCH_SCALE, Math.min(MAX_PINCH_SCALE, 
            container.zoomState.pinchState.initialScale * scaleChange));
          
          // Calculate current center point
          const currentCenter = getTouchCenter(touch1, touch2);
          const initialCenter = container.zoomState.pinchState.initialCenter;
          
          // Calculate center point movement (for panning during pinch)
          const centerDx = currentCenter.x - initialCenter.x;
          const centerDy = currentCenter.y - initialCenter.y;
          
          // Get base dimensions
          getBaseDimensions();
          
          // Calculate pan adjustment based on center movement
          // The pan needs to account for the scale change and center movement
          let panX = container.zoomState.pinchState.initialPanX;
          let panY = container.zoomState.pinchState.initialPanY;
          
          // Adjust pan based on center point movement (scaled by current scale)
          panX += centerDx / newScale;
          panY += centerDy / newScale;
          
          // Clamp pan values to prevent whitespace
          const boundaries = getPanBoundaries(newScale);
          panX = Math.max(boundaries.minX, Math.min(boundaries.maxX, panX));
          panY = Math.max(boundaries.minY, Math.min(boundaries.maxY, panY));
          
          // Update stored state with continuous scale
          container.zoomState.currentX = panX;
          container.zoomState.currentY = panY;
          container.zoomState.pinchState.currentScale = newScale;
          
          // Apply transform with continuous scale
          img.style.transform = `scale(${newScale}) translate(${panX}px, ${panY}px)`;
        }
        
        // Prevent browser zoom and page scrolling
        e.preventDefault();
        return;
      }
      
      // Single touch handling (existing panning logic)
      const touch = e.touches && e.touches[0];
      if (!touch) return;
      
      // If we were pinching and now have only one touch, transition to panning
      if (container.zoomState && container.zoomState.pinchState && container.zoomState.pinchState.isPinching && e.touches.length === 1) {
        // Pinch ended, snap to nearest discrete level
        const pinchScale = container.zoomState.pinchState.currentScale || container.zoomState.pinchState.initialScale;
        const nearestIndex = snapToNearestZoomLevel(pinchScale);
        
        // Update zoom state to nearest discrete level
        container.zoomState.zoomIndex = nearestIndex;
        const snappedScale = zoomLevels[nearestIndex];
        
        // Clamp pan to new scale boundaries
        const boundaries = getPanBoundaries(snappedScale);
        container.zoomState.currentX = Math.max(boundaries.minX, Math.min(boundaries.maxX, container.zoomState.currentX));
        container.zoomState.currentY = Math.max(boundaries.minY, Math.min(boundaries.maxY, container.zoomState.currentY));
        
        // Apply snapped scale
        img.style.transform = `scale(${snappedScale}) translate(${container.zoomState.currentX}px, ${container.zoomState.currentY}px)`;
        
        // Clear pinch state
        container.zoomState.pinchState.isPinching = false;
        
        // If zoomed, enable panning; if at 1x, re-enable Flickity
        if (snappedScale > 1) {
          isDragging = true;
          container.zoomState.isDragging = true;
          container.style.cursor = 'grabbing';
          container.zoomState.lastPointerX = touch.clientX;
          container.zoomState.lastPointerY = touch.clientY;
        } else {
          setProductSlidersDraggable(true);
        }
        
        e.preventDefault();
        return;
      }
      
      // Always check for drag detection (even when not panning) using event object
      if (container.dragState.pointerDownX !== null && container.dragState.pointerDownY !== null) {
        const currentPointerX = touch.clientX;
        const currentPointerY = touch.clientY;
        const dx = Math.abs(currentPointerX - container.dragState.pointerDownX);
        const dy = Math.abs(currentPointerY - container.dragState.pointerDownY);
        
        // If movement exceeds threshold, mark as drag gesture
        if (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD) {
          container.dragState.wasDragGesture = true;
          
          // If zoomed, start panning when movement is detected
          const currentZoomIndex = container.zoomState?.zoomIndex || 0;
          const currentScale = zoomLevels[currentZoomIndex];
          if (currentScale > 1 && (!container.zoomState.isDragging)) {
            // Start panning - this is a drag gesture on a zoomed image
            isDragging = true;
            container.zoomState.isDragging = true;
            container.style.cursor = 'grabbing';
            // Prevent default to stop Flickity and page scrolling
            e.preventDefault();
          }
        }
      }
      
      // Only do panning logic if we're actually panning (image is zoomed and dragging started)
      // Check container's stored state instead of local variable
      if (!container.zoomState || !container.zoomState.isDragging) {
        return;
      }
      
      // Get current zoom state from container
      const currentZoomIndex = container.zoomState.zoomIndex || 0;
      const scale = zoomLevels[currentZoomIndex];
      
      // Get current position from stored state
      let panX = container.zoomState.currentX || 0;
      let panY = container.zoomState.currentY || 0;
      
      // Get current pointer position directly from touch event
      const currentPointerX = touch.clientX;
      const currentPointerY = touch.clientY;
      
      // Get last pointer position (from when dragging started or last move)
      // If this is the first move after touchstart, use the initial position
      const lastX = container.zoomState.lastPointerX !== null && container.zoomState.lastPointerX !== undefined 
        ? container.zoomState.lastPointerX 
        : currentPointerX;
      const lastY = container.zoomState.lastPointerY !== null && container.zoomState.lastPointerY !== undefined 
        ? container.zoomState.lastPointerY 
        : currentPointerY;
      
      // Calculate delta (how much the touch moved since last position)
      const dx = currentPointerX - lastX;
      const dy = currentPointerY - lastY;
      
      // Update stored last position for next delta calculation
      container.zoomState.lastPointerX = currentPointerX;
      container.zoomState.lastPointerY = currentPointerY;
      
      // Update position: translate values are in the original coordinate space
      // When image is scaled 2x, moving touch 10px should translate image by 10px/2 = 5px
      // This makes the visual movement match the touch movement (5px * 2 = 10px visual)
      panX += dx / scale;
      panY += dy / scale;
      
      // Clamp pan values to prevent whitespace
      // Force recalculation of boundaries on each move to ensure accuracy (especially important on mobile)
      // Invalidate cached base dimensions to force fresh calculation
      if (container.zoomState.baseWidth && container.zoomState.baseHeight) {
        // Recalculate base dimensions to account for any container size changes
        const containerRect = container.getBoundingClientRect();
        const imgRect = img.getBoundingClientRect();
        const currentScale = container.zoomState?.zoomIndex !== undefined ? zoomLevels[container.zoomState.zoomIndex] || 1 : 1;
        
        // Recalculate base dimensions from current state
        let recalcBaseWidth = imgRect.width / currentScale;
        let recalcBaseHeight = imgRect.height / currentScale;
        
        // If recalculation is valid, update cache
        if (recalcBaseWidth > 0 && recalcBaseHeight > 0 && isFinite(recalcBaseWidth) && isFinite(recalcBaseHeight)) {
          container.zoomState.baseWidth = recalcBaseWidth;
          container.zoomState.baseHeight = recalcBaseHeight;
        } else {
          // Use container dimensions as fallback
          container.zoomState.baseWidth = containerRect.width;
          container.zoomState.baseHeight = containerRect.height;
        }
      }
      
      const boundaries = getPanBoundaries(scale);
      panX = Math.max(boundaries.minX, Math.min(boundaries.maxX, panX));
      panY = Math.max(boundaries.minY, Math.min(boundaries.maxY, panY));
      
      // Update stored state
      container.zoomState.currentX = panX;
      container.zoomState.currentY = panY;
      
      img.style.transform = `scale(${scale}) translate(${panX}px, ${panY}px)`;
      
      // Prevent page scrolling while panning
      e.preventDefault();
    }
    
    // Document-level touchend handler
    function handleDocumentTouchEnd(e) {
      // Handle pinch end (when both touches are released or only one remains)
      if (container.zoomState && container.zoomState.pinchState && container.zoomState.pinchState.isPinching) {
        // Check if pinch is actually ending (less than 2 touches remaining)
        const remainingTouches = e.touches ? e.touches.length : 0;
        
        if (remainingTouches < 2) {
          // Pinch ended - snap to nearest discrete zoom level
          const pinchScale = container.zoomState.pinchState.currentScale || container.zoomState.pinchState.initialScale;
          const nearestIndex = snapToNearestZoomLevel(pinchScale);
          
          // Update zoom state to nearest discrete level
          container.zoomState.zoomIndex = nearestIndex;
          const snappedScale = zoomLevels[nearestIndex];
          
          // Clamp pan to new scale boundaries
          const boundaries = getPanBoundaries(snappedScale);
          container.zoomState.currentX = Math.max(boundaries.minX, Math.min(boundaries.maxX, container.zoomState.currentX));
          container.zoomState.currentY = Math.max(boundaries.minY, Math.min(boundaries.maxY, container.zoomState.currentY));
          
          // Apply snapped scale
          img.style.transform = `scale(${snappedScale}) translate(${container.zoomState.currentX}px, ${container.zoomState.currentY}px)`;
          
          // Clear pinch state
          container.zoomState.pinchState.isPinching = false;
          container.zoomState.pinchState = null;
          
          // If zoomed, keep Flickity disabled; if at 1x, re-enable Flickity
          if (snappedScale > 1) {
            setProductSlidersDraggable(false);
          } else {
            setProductSlidersDraggable(true);
            // Reset position when returning to 1x
            container.zoomState.currentX = 0;
            container.zoomState.currentY = 0;
          }
          
          // If one touch remains, transition to single-touch handling
          if (remainingTouches === 1) {
            const touch = e.touches[0];
            container.dragState.pointerDownX = touch.clientX;
            container.dragState.pointerDownY = touch.clientY;
            container.zoomState.lastPointerX = touch.clientX;
            container.zoomState.lastPointerY = touch.clientY;
            
            // If zoomed, enable panning
            if (snappedScale > 1) {
              isDragging = true;
              container.zoomState.isDragging = true;
            }
          } else {
            // Both touches released - clean up
            isDragging = false;
            if (container.zoomState) {
              container.zoomState.isDragging = false;
              container.zoomState.lastPointerX = null;
              container.zoomState.lastPointerY = null;
            }
            container.style.cursor = '';
            document.removeEventListener('touchmove', handleDocumentTouchMove);
            document.removeEventListener('touchend', handleDocumentTouchEnd);
            document.removeEventListener('mousemove', handleDocumentMouseMove);
            document.removeEventListener('mouseup', handleDocumentMouseUp);
          }
          
          // Reset drag state
          setTimeout(function() {
            container.dragState.wasDragGesture = false;
            container.dragState.pointerDownX = null;
            container.dragState.pointerDownY = null;
          }, 100);
          
          return;
        }
      }
      
      const touch = e.changedTouches && e.changedTouches[0];
      if (!touch) return;
      
      // Check if this touch was on our container
      const touchTarget = document.elementFromPoint(touch.clientX, touch.clientY);
      const isOurContainer = container.contains(touchTarget);
      
      // Final check for drag detection using event object
      let wasDrag = false;
      if (container.dragState.pointerDownX !== null && container.dragState.pointerDownY !== null) {
        const currentPointerX = touch.clientX;
        const currentPointerY = touch.clientY;
        const dx = Math.abs(currentPointerX - container.dragState.pointerDownX);
        const dy = Math.abs(currentPointerY - container.dragState.pointerDownY);
        
        // If movement exceeds threshold, mark as drag gesture
        if (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD) {
          wasDrag = true;
          container.dragState.wasDragGesture = true;
        }
      }
      
      // Get current zoom state
      const currentZoomIndex = container.zoomState?.zoomIndex || 0;
      const currentScale = zoomLevels[currentZoomIndex];
      
      // Mobile tap detection: If it was a tap (not drag) on our container, trigger zoom
      // This handles mobile zoom at all zoom levels since Flickity's staticClick may not fire reliably when dragging is disabled
      // When zoomed, we need this to continue zooming; when not zoomed, we need this to start zooming
      if (isOurContainer && !wasDrag) {
        // Don't zoom if clicking on carousel navigation or buttons
        if (!touchTarget || (!touchTarget.closest('.carousel-nav') && !touchTarget.closest('button'))) {
          // If we were panning (isDragging was set in touchmove), don't zoom (user was trying to pan)
          // Only zoom if it was a quick tap without panning
          if (container.zoomState && container.zoomState.isDragging) {
            // User was panning, don't zoom
            return;
          }
          
          // Mark that we're handling this tap to prevent Flickity's staticClick from also zooming
          container.dragState.wasDragGesture = true;
          // Use requestAnimationFrame to ensure this runs after any Flickity events
          requestAnimationFrame(function() {
            // Get current state at execution time
            const currentState = zoomLevels[container.zoomState?.zoomIndex || 0];
            // Only zoom if we're still at the same scale (prevent double-zoom if Flickity also fired)
            // This check ensures we don't double-zoom, but allows continuing to zoom
            if (currentState === currentScale) {
              performZoom();
            }
          });
        }
      }
      
      if (isDragging || (container.zoomState && container.zoomState.isDragging)) {
        isDragging = false;
        if (container.zoomState) {
          container.zoomState.isDragging = false;
          container.zoomState.lastPointerX = null;
          container.zoomState.lastPointerY = null;
        }
        container.style.cursor = '';
        // Remove document-level listeners
        document.removeEventListener('mousemove', handleDocumentMouseMove);
        document.removeEventListener('mouseup', handleDocumentMouseUp);
        document.removeEventListener('touchmove', handleDocumentTouchMove);
        document.removeEventListener('touchend', handleDocumentTouchEnd);
      } else {
        // If not dragging, still remove listeners (they were attached for tap detection)
        document.removeEventListener('touchmove', handleDocumentTouchMove);
        document.removeEventListener('touchend', handleDocumentTouchEnd);
      }
      
      // Reset drag state after a short delay to allow zoom to process
      setTimeout(function() {
        container.dragState.wasDragGesture = false;
        container.dragState.pointerDownX = null;
        container.dragState.pointerDownY = null;
      }, 100);
    }
    
    // Use Flickity's pointerMove event (only for drag detection, not for panning)
    function handlePointerMove(event, pointer) {
      // Always check for drag detection (even when not panning) using event object
      if (container.dragState.pointerDownX !== null && container.dragState.pointerDownY !== null) {
        const currentPointerX = event.clientX !== undefined ? event.clientX : (event.touches && event.touches[0] ? event.touches[0].clientX : pointer.pageX || pointer.clientX);
        const currentPointerY = event.clientY !== undefined ? event.clientY : (event.touches && event.touches[0] ? event.touches[0].clientY : pointer.pageY || pointer.clientY);
        const dx = Math.abs(currentPointerX - container.dragState.pointerDownX);
        const dy = Math.abs(currentPointerY - container.dragState.pointerDownY);
        
        // If movement exceeds threshold, mark as drag gesture
        if (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD) {
          container.dragState.wasDragGesture = true;
        }
      }
      
      // DON'T do panning logic here - we use document-level handlers for that
      // This prevents double updates and ensures consistent behavior
      // The document-level handlers will handle all panning
    }
    
    // Use Flickity's pointerUp event (fallback, may not fire when draggable is false)
    function handlePointerUp(event, pointer) {
      // Final check for drag detection using event object
      if (container.dragState.pointerDownX !== null && container.dragState.pointerDownY !== null) {
        const currentPointerX = event.clientX !== undefined ? event.clientX : (event.changedTouches && event.changedTouches[0] ? event.changedTouches[0].clientX : pointer.pageX || pointer.clientX);
        const currentPointerY = event.clientY !== undefined ? event.clientY : (event.changedTouches && event.changedTouches[0] ? event.changedTouches[0].clientY : pointer.pageY || pointer.clientY);
        const dx = Math.abs(currentPointerX - container.dragState.pointerDownX);
        const dy = Math.abs(currentPointerY - container.dragState.pointerDownY);
        
        // If movement exceeds threshold, mark as drag gesture
        if (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD) {
          container.dragState.wasDragGesture = true;
        }
      }
      
      // Note: Don't reset dragState here - let staticClick handler check it first
      // It will reset after handling the click (or skipping it if drag was detected)
      // Also, document mouseup handler will handle cleanup
    }
    
    // Attach native DOM event listeners (primary - works even when Flickity draggable is false)
    container.addEventListener('mousedown', handleContainerMouseDown);
    container.addEventListener('touchstart', handleContainerTouchStart, { passive: false });
    
    // Attach Flickity event listeners (fallback)
    // Use jQuery event binding for Flickity events
    const $carousel = $(container.closest('.carousel-main'));
    if ($carousel.length) {
      $carousel.on('staticClick.flickity', handleStaticClick);
      $carousel.on('pointerDown.flickity', handlePointerDown);
      $carousel.on('pointerMove.flickity', handlePointerMove);
      $carousel.on('pointerUp.flickity', handlePointerUp);
      // Note: We don't listen to dragStart because it can fire incorrectly
      // Our own drag detection in pointerMove/pointerUp is more reliable
    }
    
    // Clean up on container removal
    container.addEventListener('DOMNodeRemoved', function() {
      // Remove native DOM listeners
      container.removeEventListener('mousedown', handleContainerMouseDown);
      container.removeEventListener('touchstart', handleContainerTouchStart);
      
      if ($carousel.length) {
        $carousel.off('staticClick.flickity', handleStaticClick);
        $carousel.off('pointerDown.flickity', handlePointerDown);
        $carousel.off('pointerMove.flickity', handlePointerMove);
        $carousel.off('pointerUp.flickity', handlePointerUp);
        $carousel.off('dragStart.flickity');
      }
      // Remove document-level listeners
      document.removeEventListener('mousemove', handleDocumentMouseMove);
      document.removeEventListener('mouseup', handleDocumentMouseUp);
      document.removeEventListener('touchmove', handleDocumentTouchMove);
      document.removeEventListener('touchend', handleDocumentTouchEnd);
    });
  }
  
  // Initialize zoom for all carousel cells
  // Ensure Flickity is initialized for a carousel
  function ensureFlickityInitialized(carousel) {
    // Check if jQuery and Flickity are available
    if (typeof $ === 'undefined' || typeof $.fn.flickity === 'undefined') {
      return;
    }
    
    const $carousel = $(carousel);
    if (!$carousel.length) return;
    
    // Check if Flickity is already initialized
    if ($carousel.data('flickity')) {
      return;
    }
    
    // Initialize Flickity with default product carousel options
    // Match the options from theme.js for .carousel-main.js-pr-nw-top
    const isMobile = carousel.closest('.img-mobile-slider');
    
    try {
      if (isMobile) {
        // Mobile carousel options
        $carousel.flickity({
          prevNextButtons: false,
          fullscreen: true,
          freeScroll: false,
          percentPosition: true
        });
      } else {
        // Desktop carousel options
        $carousel.flickity({
          prevNextButtons: false,
          imagesLoaded: true
        });
      }
    } catch (error) {
      // Silently fail if initialization fails
      // This prevents errors if Flickity is not fully loaded yet
    }
  }
  
  function initAllZoomContainers() {
    // Desktop carousel - use generic selector (any .carousel-main not inside .img-mobile-slider)
    const desktopCarousels = document.querySelectorAll('.carousel-main');
    const desktopCells = [];
    desktopCarousels.forEach(function(carousel) {
      // Skip mobile carousel
      if (!carousel.closest('.img-mobile-slider')) {
        // Ensure Flickity is initialized before processing cells
        ensureFlickityInitialized(carousel);
        
        const cells = carousel.querySelectorAll('.carousel-cell');
        cells.forEach(function(cell) {
          desktopCells.push(cell);
        });
      }
    });
    desktopCells.forEach(function(cell) {
      const img = cell.querySelector('img.sp.easyOverlayImage, img.easyOverlayImage');
      if (img && !cell.dataset.zoomInitialized) {
        initZoomForContainer(cell, img);
      }
    });
    
    // Mobile carousel (for when resized to desktop)
    const mobileCarousels = document.querySelectorAll('.img-mobile-slider .carousel-main');
    mobileCarousels.forEach(function(carousel) {
      // Ensure Flickity is initialized before processing cells
      ensureFlickityInitialized(carousel);
    });
    
    const mobileCells = document.querySelectorAll('.img-mobile-slider .carousel-main .carousel-cell');
    mobileCells.forEach(function(cell) {
      const img = cell.querySelector('img.easyOverlayImage');
      if (img && !cell.dataset.zoomInitialized) {
        initZoomForContainer(cell, img);
      }
    });
  }
  
  // Initialize on page load
  function initZoom() {
    // Wait for images to be in DOM
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllZoomContainers);
    } else {
      // Small delay to ensure carousel is initialized
      setTimeout(initAllZoomContainers, 500);
    }
  }
  
  // Reinitialize when carousel is rebuilt (variant changes)
  const observer = new MutationObserver(function(mutations) {
    let shouldReinit = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            if (node.classList && (
              node.classList.contains('carousel-cell') ||
              node.querySelector('.carousel-cell')
            )) {
              shouldReinit = true;
            }
          }
        });
      }
    });
    
    if (shouldReinit) {
      setTimeout(initAllZoomContainers, 100);
    }
  });
  
  // Observe the carousel containers
  function startObserving() {
    // Use generic selector for desktop carousel (not inside .img-mobile-slider)
    const allCarousels = document.querySelectorAll('.carousel-main');
    let desktopCarousel = null;
    for (let i = 0; i < allCarousels.length; i++) {
      if (!allCarousels[i].closest('.img-mobile-slider')) {
        desktopCarousel = allCarousels[i];
        break;
      }
    }
    const mobileCarousel = document.querySelector('.img-mobile-slider .carousel-main');
    
    if (desktopCarousel) {
      observer.observe(desktopCarousel, { childList: true, subtree: true });
    }
    if (mobileCarousel) {
      observer.observe(mobileCarousel, { childList: true, subtree: true });
    }
  }
  
  // Handle window resize
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      initAllZoomContainers();
    }, 250);
  });
  
  // Reset drag state when Flickity changes slides
  function resetDragStateOnSlideChange() {
    // Use generic selector for desktop carousel (not inside .img-mobile-slider)
    const $mainSlider = $('.carousel-main').not('.img-mobile-slider .carousel-main').first();
    const $mobileSlider = $('.img-mobile-slider .carousel-main');
    
    // Reset drag state for all cells when slide changes
    function resetAllCellsDragState() {
      const allCells = document.querySelectorAll('.carousel-main .carousel-cell');
      allCells.forEach(function(cell) {
        if (cell.dragState) {
          cell.dragState.wasDragGesture = false;
          cell.dragState.pointerDownX = null;
          cell.dragState.pointerDownY = null;
        }
      });
    }
    
    if ($mainSlider.length && $mainSlider.data('flickity')) {
      $mainSlider.on('change.flickity', function() {
        resetAllCellsDragState();
      });
      $mainSlider.on('select.flickity', function() {
        resetAllCellsDragState();
      });
    }
    
    if ($mobileSlider.length && $mobileSlider.data('flickity')) {
      $mobileSlider.on('change.flickity', function() {
        resetAllCellsDragState();
      });
      $mobileSlider.on('select.flickity', function() {
        resetAllCellsDragState();
      });
    }
  }
  
  // Start initialization
  initZoom();
  
  // Start observing after a delay to ensure carousels are ready
  setTimeout(function() {
    startObserving();
    initAllZoomContainers();
    // Set up slide change listeners after carousels are initialized
    resetDragStateOnSlideChange();
  }, 1000);
  
})();

